import React, { useState, useEffect, useContext, useCallback } from 'react';
import { TextButton, Box, Typography, visuallyHidden } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import { Keywords } from 'components';
import WelcomeFooter from '../WelcomeFooter';
import { VENDORS_ME } from 'constants/apis';
import { ToastContext } from 'contexts';
import axios from 'helpers/axios';

const PAPER_MAX_WIDTH = '1000px';

const Welcome5 = ({
  values,
  setHasVisitedKeywords,
  decrementIndex,
  onSubmit: _onSubmit,
  completeOnboarding,
}) => {
  const { t } = useTranslation();
  const toastContext = useContext(ToastContext);
  const [isRemovingKeyword, setIsRemovingKeyword] = useState(false);

  useEffect(() => setHasVisitedKeywords(true), [setHasVisitedKeywords]);

  const onSubmit = useCallback(
    async newKeywords => {
      const payload = {
        keywords: newKeywords,
      };
      _onSubmit({ keywords: newKeywords });
      try {
        await axios.patch(VENDORS_ME, payload);
      } catch (err) {
        toastContext.triggerToast({});
      }
    },
    [_onSubmit, toastContext]
  );

  const onRemoveKeyword = useCallback(
    async newKeywords => {
      try {
        setIsRemovingKeyword(true);
        await onSubmit(newKeywords);
      } catch (err) {
        toastContext.triggerToast({});
      } finally {
        setIsRemovingKeyword(false);
      }
    },
    [onSubmit, toastContext]
  );

  return (
    <>
      <Box mb={5}>
        <Typography component="h1" sx={visuallyHidden}>
          {t('welcome.keywords.title')}
        </Typography>
        <Typography variant="h4" component="h2">
          {t('welcome.keywords.intro')}
        </Typography>
        <Typography variant="body2" sx={{ my: theme => theme.spacing(3) }}>
          {t('welcome.keywords.reason')}
        </Typography>
        <Keywords
          keywords={values.keywords}
          onSubmit={onSubmit}
          onRemoveKeyword={onRemoveKeyword}
          isMutating={isRemovingKeyword}
        />
      </Box>
      <WelcomeFooter stickyWidth={PAPER_MAX_WIDTH} isStickyBar>
        <TextButton
          variant="text"
          label={`< ${t('components.back')}`}
          sx={{ fontWeight: '600' }}
          onClick={() => decrementIndex()}
        />
        <TextButton
          variant="contained"
          color="primary"
          label={t('welcome.complete')}
          onClick={completeOnboarding}
        />
      </WelcomeFooter>
    </>
  );
};

export default Welcome5;
